module.exports = __webpack_public_path__ + "static/diyanet4-cd6e2d4be826e9cccb0801a3915f4bc9.png";